import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, X } from 'lucide-react';
import api from '../api';

export default function ClientiAttivi() {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tutti, setTutti] = useState([]);
  const inputRef = useRef(null);

  useEffect(() => {
    // Carica tutti i clienti attivi inizialmente
    api.get('/home/clienti_attivi/search?q=&limit=20').then(r => setTutti(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!query.trim()) { setResults([]); return; }
    setLoading(true);
    const t = setTimeout(() => {
      api.get(`/home/clienti_attivi/search?q=${encodeURIComponent(query)}&limit=5`)
        .then(r => { setResults(r.data); setLoading(false); })
        .catch(() => setLoading(false));
    }, 200);
    return () => clearTimeout(t);
  }, [query]);

  function initials(nome) {
    return nome.split(' ').map(w => w[0]).join('').toUpperCase().slice(0,2);
  }

  const colori = ['#a855f7','#00d4ff','#10b981','#f59e0b','#f43f5e','#3b82f6'];
  function color(nome) { return colori[nome.charCodeAt(0) % colori.length]; }

  // Salute cliente: rosso = task scaduti, giallo = task in scadenza oggi, verde = ok
  function salute(c) {
    if ((c.task_scaduti || 0) > 0) return { dot:'var(--red)',    label:`${c.task_scaduti} task scadut${c.task_scaduti===1?'a':'e'}` };
    if ((c.task_oggi || 0) > 0)    return { dot:'var(--yellow)', label:`${c.task_oggi} task in scadenza oggi` };
    return { dot:'var(--green)', label: (c.task_aperti||0) > 0 ? `${c.task_aperti} task aperti, in pari` : 'Nessuna scadenza critica' };
  }

  return (
    <div className="eden-page eden-page--narrow">
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontSize:22, fontWeight:700, margin:'0 0 4px', color:'var(--text)' }}>Clienti attivi</h1>
        <p style={{ fontSize:13, color:'var(--text-muted)', margin:0 }}>Cerca e apri la scheda cliente.</p>
      </div>

      {/* Search */}
      <div style={{ position:'relative', marginBottom:28 }}>
        <Search size={15} style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'var(--text-dim)' }}/>
        <input
          ref={inputRef}
          autoFocus
          value={query}
          onChange={e => setQuery(e.target.value)}
          placeholder="Cerca cliente per nome o azienda…"
          className="eden-input"
          style={{ paddingLeft:36, paddingRight:36, fontSize:14 }}
        />
        {query && (
          <button onClick={() => setQuery('')} style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--text-dim)', display:'flex' }}>
            <X size={14}/>
          </button>
        )}

        {/* Dropdown risultati */}
        {query && (
          <div style={{
            position:'absolute', top:'calc(100% + 6px)', left:0, right:0,
            background:'var(--bg2)', border:'1px solid var(--border)',
            borderRadius:12, boxShadow:'0 12px 40px rgba(0,0,0,0.4)',
            zIndex:200, overflow:'hidden',
          }}>
            {loading ? (
              <div style={{ padding:16, textAlign:'center', color:'var(--text-dim)', fontSize:13 }}>Ricerca…</div>
            ) : results.length === 0 ? (
              <div style={{ padding:16, textAlign:'center', color:'var(--text-dim)', fontSize:13 }}>Nessun cliente trovato</div>
            ) : (
              <>
                <div style={{ padding:'6px 12px 4px', fontSize:10.5, color:'var(--text-dim)' }}>max 5 risultati</div>
                {results.map(c => (
                  <div key={c.id} onClick={() => navigate(`/clienti/${c.id}`)}
                    style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px', cursor:'pointer', transition:'background 0.1s' }}
                    onMouseEnter={e => e.currentTarget.style.background='var(--surface-h)'}
                    onMouseLeave={e => e.currentTarget.style.background='transparent'}
                  >
                    <div style={{ width:28, height:28, borderRadius:'50%', overflow:'hidden', background: c.logo_url?'var(--surface)':`${color(c.azienda||c.nome)}22`, border:`1.5px solid ${c.logo_url?'var(--border)':color(c.azienda||c.nome)+'55'}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:10, fontWeight:700, color:color(c.azienda||c.nome), flexShrink:0 }}>
                      {c.logo_url ? <img src={c.logo_url} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/> : initials(c.azienda||c.nome)}
                    </div>
                    <div>
                      <div style={{ fontSize:13, fontWeight:500, color:'var(--text)' }}>{c.azienda || c.nome}</div>
                      {c.azienda && c.nome && <div style={{ fontSize:11, color:'var(--text-muted)' }}>{c.nome}</div>}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        )}
      </div>

      {/* Griglia tutti i clienti attivi */}
      {!query && (
        <>
          <div style={{ fontSize:12, fontWeight:600, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:12 }}>
            Tutti i clienti attivi ({tutti.length})
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(220px,1fr))', gap:10 }}>
            {tutti.map(c => (
              <div key={c.id} onClick={() => navigate(`/clienti/${c.id}`)}
                style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:12, padding:'14px 16px', cursor:'pointer', transition:'border-color 0.15s, background 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='rgba(0,212,255,0.3)'; e.currentTarget.style.background='var(--surface-h)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.background='var(--surface)'; }}
              >
                <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8 }}>
                  <div style={{ position:'relative', flexShrink:0 }}>
                    <div style={{ width:32, height:32, borderRadius:'50%', overflow:'hidden', background: c.logo_url?'var(--surface)':`${color(c.azienda||c.nome)}22`, border:`1.5px solid ${c.logo_url?'var(--border)':color(c.azienda||c.nome)+'55'}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, color:color(c.azienda||c.nome) }}>
                      {c.logo_url ? <img src={c.logo_url} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/> : initials(c.azienda||c.nome)}
                    </div>
                    {(() => { const s = salute(c); return (
                      <span title={s.label} style={{ position:'absolute', bottom:-1, right:-1, width:11, height:11, borderRadius:'50%', background:s.dot, border:'2px solid var(--surface)' }}/>
                    ); })()}
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:13, fontWeight:600, color:'var(--text)' }}>{c.azienda || c.nome}</div>
                    {c.azienda && c.nome && <div style={{ fontSize:11, color:'var(--text-muted)' }}>{c.nome}</div>}
                  </div>
                </div>
                <div style={{ fontSize:11, color:'var(--cyan)' }}>Apri scheda →</div>
              </div>
            ))}
            {tutti.length === 0 && (
              <div style={{ color:'var(--text-dim)', fontSize:13, gridColumn:'1/-1', padding:24, textAlign:'center' }}>
                Nessun cliente attivo
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
